/* tslint-disable */
import { PROGRESS } from "@lhd/features/ProjectManagement/hook";
import { get, join, toString } from "lodash";
import { IData } from "../hook";
import { MouseClickRightSvg } from "@lhd/assets";
import moment from "moment";

export const useColumns = () => {
  return [
    {
      columnId: "index",
      label: "No.",
      type: "text",
      width: 30,
      editable: false,
      icon: <></>,
    },
    {
      label: "タスクタイトル",
      columnId: "title",
      minWidth: 230,
      type: "text",
      icon: <></>,
    },
    {
      label: "社員名",
      columnId: "workers_name",
      minWidth: 230,
      type: "text",
      icon: <MouseClickRightSvg />,
    },
    {
      label: "予定開始日",
      columnId: "start_at",
      minWidth: 230,
      type: "dateTimeCustom",
      icon: <></>,
    },
    {
      label: "予定終了日",
      columnId: "end_at",
      minWidth: 140,
      // type: "date",
      type: "dateTimeCustom",
      icon: <></>,
    },
    {
      label: "親タスク",
      columnId: "parent_task_title",
      minWidth: 230,
      type: "text",
      icon: <MouseClickRightSvg />,
    },
    {
      label: "進捗",
      columnId: "progress",
      minWidth: 140,
      type: "text",
      icon: <></>,
    },
    {
      label: "状態",
      columnId: "status",
      minWidth: 140,
      type: "text",
      icon: <MouseClickRightSvg />,
      cellRenderer: (e: any) => {
        return <div>{get(PROGRESS, e.value, "")}</div>;
      },
    },
    {
      label: "実施開始日",
      columnId: "achieve_start_at",
      minWidth: 140,
      type: "dateTimeCustom",
      icon: <></>,
    },
    {
      label: "実施終了日",
      columnId: "achieve_end_at",
      minWidth: 140,
      type: "dateTimeCustom",
      icon: <></>,
    },
  ];
};

export const handleData = (data: any[]) => {
  return [
    ...data,
    ...Array.from(
      Array(data.length > 1000 ? 0 : 1000 - data.length).keys(),
    ).map((_) => ({
      title: "",
      workers_name: "",
      start_at: "",
      end_at: "",
      parent_task_title: "",
      progress: "",
      status: "",
      achieve_start_at: "",
      achieve_end_at: "",
      parent_task_id: "",
      taskId: null,
      project_id: null,
      worker_ids: "",
    })),
  ];
};

export const checkInvalid = (
  data: IData,
  fields?: string[],
  countFieldValidate?: number,
) => {
  let result = false;
  let haveData = false;
  let countFieldInvalid = 0;
  if (fields) {
    fields.forEach((fieldItem) => {
      if (
        !data?.[fieldItem as keyof IData] ||
        data?.[fieldItem as keyof IData] === ""
      ) {
        result = true;
        countFieldInvalid = countFieldInvalid + 1;
      } else {
        haveData = true;
      }
    });
  } else {
    Object.keys(data).forEach((keyItem: string) => {
      if (
        !data?.[keyItem as keyof IData] ||
        data?.[keyItem as keyof IData] === ""
      ) {
        result = true;
      } else {
        haveData = true;
      }
    });
  }
  return {
    invalid:
      countFieldValidate === undefined
        ? result
        : result && fields && countFieldInvalid === countFieldValidate,
    haveData,
  };
};

export const convertItem = (item: IData) => {
  return {
    ...item,
    progress: toString(item.progress),
    start_at: item.start_at ? moment(item.start_at).format("YYYY-MM-DD") : "",
    end_at: item.end_at ? moment(item.end_at).format("YYYY-MM-DD") : "",
    achieve_start_at: item.achieve_start_at
      ? moment(item.achieve_start_at).format("YYYY-MM-DD")
      : "",
    achieve_end_at: item.achieve_end_at
      ? moment(item.achieve_end_at).format("YYYY-MM-DD")
      : "",
    taskId: toString(item.id),
    parent_task_title: item.parent_task
      ? toString(item?.parent_task?.title)
      : toString(item.parent_task_title),
    workers_name: item.workers
      ? join(
          item.workers.map((worker) => worker.full_name),
          ", ",
        )
      : toString(item.workers_name),
  };
};
export const task_sheet_fields_convert_attr = [
  "workers_name",
  "parent_task_title",
  "status",
];
